// extracted by mini-css-extract-plugin
export default {"component":"ParticipantsToShareComponent_component__JQIb4","rightBody":"ParticipantsToShareComponent_rightBody__bvWcp","icon":"ParticipantsToShareComponent_icon__Tlx4e"};